/* eslint-disable prettier/prettier */
import CloseIcon from "@mui/icons-material/Close";
import DVRIcon from "@mui/icons-material/Dvr";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  InputLabel,
  Checkbox,
  Grid,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Dialog,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import _ from "lodash";
import PropTypes from "prop-types";
import { useState } from "react";

import { GRID } from "../../../../../containers/smartForms/components/constants";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import BPMNDiagram from "../../BPMNDiagram";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  position: "relative",
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));

const ModelerModalCopyField = ({
  xmldata,
  selectedTaskName,
  saveForm,
  businessObject,
  element,
  extensionElements,
  selectBox,
  bpmnFactory,
}) => {
  const [open, setOpen] = useState(true);
  const [selectfields, setSelectfields] = useState([]);
  const [objField, setObjField] = useState([]);

  const handleClose = () => {
    setOpen(false);
  };

  const onSave = () => {
    const selectItens = selectfields || [];
    saveForm(
      businessObject,
      element,
      extensionElements,
      selectBox,
      bpmnFactory,
      selectItens,
    );

    setSelectfields([]);
    setOpen(false);
  };

  const handleToogle = (data) => {
    setSelectfields((prev) => {
      const prevFields = prev || [];
      const currentIndex = prevFields.findIndex(
        (item) => item.id === data.id && item.parentId === data.parentId
      );

      const newFields = [...prevFields];

      if (currentIndex === -1) {
        newFields.push({
          id: data.id,
          label: data.label,
          parentId: data.parentId,
          checked: true,
        });
      } else {
        newFields[currentIndex] = {
          ...newFields[currentIndex],
          checked: !newFields[currentIndex].checked,
        };
      }
      
      return newFields;
    });
  };

  const getGridDetails = (fields, parentId) => {
    const formfields = [];
    for (let linha = 0; linha < fields.items.length; linha++) {
      const rows = fields.items[linha];
      for (let column = 0; column < rows.items.length; column++) {
        const col = rows.items[column];

        for (let content = 0; content < col.items.length; content++) {
          const cont = col.items[content];
          formfields.push({
            id: cont.id,
            label: cont.label,
            parentId,
            type: cont.type,
          });
        }
      }
    }
    return formfields;
  };

  const getDetailProps = (fields, parentId) => {
    const formfields = [];
    let ntype = null;
    let jsondata = {};
    for (let i = 0; i < fields.length; i++) {
      if (
        fields[i] &&
        fields[i].$children &&
        fields[i].$children[0] &&
        fields[i].$children[0].$children &&
        fields[i].$children[0].$children[0] &&
        fields[i].$children[0].$children[0].smart &&
        fields[i].$children[0].$children[0].smart === "true"
      ) {
        jsondata = JSON.parse(fields[i].$children[0].$children[0].value);
        ntype = jsondata.type;
      } else {
        ntype = null;
        jsondata = {};
      }

      const item = {
        id: fields[i].id,
        label: fields[i].label,
        parentId,
        type: ntype,
      };
      formfields.push(item);

      if (ntype === GRID) {
        const griddata = getGridDetails(jsondata, fields[i].id);
        Array.prototype.push.apply(formfields, griddata);
      }
    }
    return formfields;
  };

  const ischecks = () => {
    if (selectfields) {
      return _.find(selectfields, function (a) {
        return a.checked === true;
      });
    }

    return false;
  };

  const getPropertiesElement = (element) => {
    let data = null;

    if (element && element.values) {
      for (let i = 0; i < element.values.length; i++) {
        if (element.values[i].$type === "camunda:formData") {
          data = element.values[i];
        }
      }
    }
    return data;
  };

  const handleElementChange = (elem) => {
    let data = null;
    let formfields = [];
    const listexistFields = [];
    const businessObject = elem ? elem.businessObject : null;
    if (
      businessObject &&
      (businessObject.$type === "bpmn:StartEvent" ||
        businessObject.$type === "bpmn:UserTask")
    ) {
      if (
        businessObject.extensionElements &&
        businessObject.extensionElements.$type === "bpmn:ExtensionElements"
      ) {
        data = getPropertiesElement(businessObject.extensionElements);
        if (data && data.$children && data.$children.length > 0) {
          const fields = getDetailProps(data.$children, businessObject.id);
          const listAdd = [];
          for (let i = 0; i < fields.length; i++) {
            const existField = listexistFields.find(function (f) {
              // eslint-disable-line no-loop-func
              if (f.id === fields[i].id) {
                return true;
              }
              return false;
            });
            if (!existField) {
              listAdd.push(fields[i]);
            }
          }

          formfields = {
            activityName:
              businessObject.name && businessObject.name.length > 0
                ? businessObject.name
                : businessObject.id,
            id: businessObject.id,
            fields: listAdd,
          };
          setObjField(formfields);
        }
      }
    }
  };

  const isInvalid = !ischecks();
  return (
    <Provider>
      <Dialog fullScreen open={open} onClose={handleClose}>
        <StyledAppBar color="default">
          <Toolbar>
            <IconButton
              edge="start"
              color="secondary"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <StyledTypography variant="h6">
              SmartForm - {language.copyFieldTo} {selectedTaskName}
            </StyledTypography>
            <Button
              autoFocus
              color="secondary"
              onClick={onSave}
              disabled={isInvalid}
            >
              {language.save}
            </Button>
          </Toolbar>
        </StyledAppBar>
        <div>
          <Grid container>
            <Grid item xs={3}>
              {objField.fields ? (
                <InputLabel htmlFor="age-native-simple">
                  <DVRIcon />
                  {objField.activityName}
                </InputLabel>
              ) : (
                <InputLabel htmlFor="age-native-simple">
                  <InfoOutlinedIcon />
                  {language.noFieldCreated}
                </InputLabel>
              )}
              <List>
                {objField.fields?.map((data) => {
                  const selectionItem = selectfields.find(
                    (item) =>
                      item.id === data.id && item.parentId === data.parentId,
                  );

                  const isChecked = selectionItem
                    ? selectionItem.checked
                    : false;

                  return (
                    <ListItem key={data.id} disablePadding>
                      <ListItemButton
                        role={undefined}
                        onClick={() => handleToogle(data)}
                        dense
                      >
                        <ListItemIcon>
                          <Checkbox
                            edge="start"
                            checked={isChecked}
                            tabIndex={-1}
                            disableRipple
                            inputProps={{ "aria-labelledby": data.id }}
                          />
                        </ListItemIcon>
                        <ListItemText
                          id={data.id}
                          primary={data.label || data.id}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>
            </Grid>
            <Grid
              item
              xs={9}
              style={{ padding: "0.5%", borderLeftStyle: "groove" }}
            >
              <BPMNDiagram
                xml={xmldata}
                markers={[]}
                style={{ height: "88vh" }}
                ParentChange={handleElementChange}
              />
            </Grid>
          </Grid>
        </div>
      </Dialog>
    </Provider>
  );
};

ModelerModalCopyField.propTypes = {
  xmldata: PropTypes.string,
  selectedTaskName: PropTypes.string,
  saveForm: PropTypes.func,
  businessObject: PropTypes.object,
  element: PropTypes.object,
  extensionElements: PropTypes.object,
  selectBox: PropTypes.object,
  bpmnFactory: PropTypes.object,
};

export default ModelerModalCopyField;
